import { render, staticRenderFns } from "./TitanEditDetails.vue?vue&type=template&id=78672f6e&"
import script from "./TitanEditDetails.vue?vue&type=script&lang=js&"
export * from "./TitanEditDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports